//Dashboard.js
import React, { PureComponent } from "react";
import { StyleSheet, css } from "aphrodite/no-important";
import { PropagateLoader } from "react-spinners";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import ButtonBase from "@material-ui/core/ButtonBase";
import MagentoLogo from "imgs/magento_logo.png";
import Server from "components/Server";
import CheckCircle from "@material-ui/icons/CheckCircle";
import Cancel from "@material-ui/icons/Cancel";

const classes = StyleSheet.create({
	dashboard: {
		width: "100%",
		height: "100%",
		maxWidth: "100%"
	},
	connectionModel: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		width: "100%",
		height: "100%"
	},
	iframe: {
		width: "100%",
		height: "100%",
		padding: "0px",
		margin: "0px",
		border: "0px solid white"
	},
	loading: {
		padding: "0px",
		margin: "0px",
		position: "absolute",
		top: "65px",
		right: "200px",
		height: "100%"
	},
	paper: {
		flexGrow: 1,
		maxWidth: 500,
		padding: "5px",
		position: "relative",
		overflow: "hidden",
		flexWrap: "nowrap"
	},
	image: {
		width: 128,
		height: 128
	},
	img: {
		margin: "auto",
		display: "block",
		maxWidth: "100%",
		maxHeight: "100%"
	},
	checkCircle: {
		color: "#2ecc71",
		fontSize: "40px"
	},
	cancel: {
		color: "#e74c3c",
		fontSize: "40px"
	},
	p: {
		width: "100%",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		overflow: "hidden"
	}
});

class Dashboard extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			connected: null,
			url: ""
		};
	}

	componentDidMount() {
		this.isConnected();
	}

	isConnected(setState = false) {
		if (setState) this.setState({ connected: null, url: "" });
		Server.post(
			"/settings/isconnected",
			null,
			this.isConnectedDone.bind(this)
		);
	}

	isConnectedDone(res) {
		if (res.data.isconnected != null)
			this.setState({
				connected: res.data.isconnected,
				url: res.data.url
			});
	}

	loading() {
		return (
			<div className={css(classes.loading)}>
				<PropagateLoader color={"#123abc"} loading={true} size={8} />
			</div>
		);
	}

	dashboard() {
		return (
			<div className={css(classes.connectionModel)}>
				<Paper className={css(classes.paper)}>
					<Grid container spacing={1} style={{ flexWrap: "nowrap" }}>
						<Grid item>
							<ButtonBase
								className={css(classes.image)}
								onClick={() => this.isConnected(true)}
							>
								<img
									className={css(classes.img)}
									alt="complex"
									src={MagentoLogo}
								/>
							</ButtonBase>
						</Grid>
						{this.state.connected == null ? (
							this.loading()
						) : (
							<Grid
								item
								xs={12}
								sm
								container
								style={{ width: "calc(100% - 139px)" }}
							>
								<Grid
									item
									xs
									container
									direction="column"
									spacing={2}
									style={{ padding: "15px 0px" }}
								>
									<Grid item xs>
                                        <div style={{display: "flex", justifyContent: "start", alignItems: "center"}}>
                                            <Typography
                                                gutterBottom
                                                variant="subheading"
                                            >
                                                {this.state.connected == true ? (
                                                    <CheckCircle
                                                        className={css(
                                                            classes.checkCircle
                                                        )}
                                                    />
                                                ) : (
                                                    <Cancel
                                                        className={css(
                                                            classes.cancel
                                                        )}
                                                    />
                                                )}
                                            </Typography>
                                            <div style={{height:"26px", marginLeft: "7px"}}>
                                                <Typography
                                                    gutterBottom
                                                    variant="headline"
                                                >
                                                    {this.state.connected == true
                                                        ? "Connected"
                                                        : "Not Connected"}
                                                </Typography>
                                            </div>
                                        </div>
										<Typography
											className={css(classes.p)}
											color="textSecondary"
										>
											{this.state.url}
										</Typography>
									</Grid>
								</Grid>
							</Grid>
						)}
					</Grid>
				</Paper>
			</div>
		);
	}

	render() {
		return (
			this.props.open && (
				<div style={this.props.style} id="Dashboard">
					{this.dashboard()}
				</div>
			)
		);
	}
}

export default Dashboard;
